import { KYMW9300Component } from './kymw9300.component';

/**
 * お知らせ編集画面の値を管理するクラス
 *
 * @export KYMW9300Model
 * @class KYMW9300Model
 */
export class KYMW9300Model {

  KYMW9300Component: KYMW9300Component;

  /** ログイン画面お知らせ */
  public loginInformation: string = <string>'';

  /** トップ画面お知らせ */
  public topInformation: string = <string>'';

  /** ログイン画面活性非活性判定 */
  public INFO1ToFlg: boolean = <boolean> false;

  /** トップ画面活性非活性判定 */
  public INFO2ToFlg: boolean = <boolean> false;

  /** 設定ボタン活性非活性判定 */
  public btnUpdateToFlg: boolean = <boolean> false;

  /** 画面の再描画 */
  public updateInformations(serverData: any) {
    // サーバから受信したデータがNULLでないか
    if (serverData != null && serverData.ForWholeInfo != null) {
      // 各データの設定
      // ログイン画面お知らせ
      this.loginInformation = serverData.ForWholeInfo.LoginInfo;

      // トップ画面お知らせ
      this.topInformation = serverData.ForWholeInfo.TopInfo;
    }
  }
}

